import React, { useCallback, useState, FC } from 'react'
import { useTheme, Dialog, Slide, Paper, Tooltip, IconButton } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { ProductUpdate } from './ProductUpdateDialog';
import EditIcon from '@material-ui/icons/Edit'
import { ProductUpdateFormData } from '../models/products.model';

interface ProductBasicEditProps {
    productName: string;
    product: ProductUpdateFormData,
    onSuccess: (data?: any) => void,
}
export const ProductBasicEdit: FC<ProductBasicEditProps> = ({ productName, product, onSuccess }) => {

    const [showProductEdit, setProductEdit] = useState(false);


    const handleEditClose = useCallback(() => {
        setProductEdit(false);
    }, []);

    const handleEditOpen = useCallback(() => {

        setProductEdit(true);
    }, []);

    const handleEditUpdate = useCallback((data) => {
        setProductEdit(false);
        onSuccess(data);
    }, []);

    const theme = useTheme();

    const transitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen,
    };

    return (
        <>
            <Tooltip title={<FormattedMessage defaultMessage="Edit configuration" />}>
                <IconButton disabled={true} onClick={handleEditOpen} size="small">
                    <EditIcon />
                </IconButton>
            </Tooltip>

            <Dialog
                fullWidth={true}
                open={showProductEdit}
                onClose={handleEditClose}
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
            >


                <Slide direction="left" timeout={transitionDuration} style={{
                    transitionTimingFunction: theme.transitions.easing.easeInOut
                }} in={showProductEdit} mountOnEnter unmountOnExit>
                    <Paper>
                        <ProductUpdate productName={productName} product={product} onClose={handleEditClose} onSuccess={handleEditUpdate} />
                    </Paper>
                </Slide>
            </Dialog>
        </>
    );
}